import { render } from "./success.vue?vue&type=template&id=9a0bbab4&lang=pug"
import script from "./success.vue?vue&type=script&setup=true&lang=js"
export * from "./success.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__